import { message, Switch } from "antd";
import { useState } from "react";

// Cell renderer for subscription-level switches
export function SubscriptionSwitchCellRenderer({
  value,
  data: rowData,
  context,
  colDef,
  node
}: any) {
  const [loading, setLoading] = useState(false);

  const handleChange = async (checked: boolean) => {
    const feature = colDef?.field?.split(".")[0];

    if (!feature || !rowData.id) return;

    // Find the product entitlement ID for this feature
    const featureFlag = rowData.subscription_product_entitlements?.find(
      (e: any) => e.product_entitlement?.feature === feature
    );

    if (!featureFlag) {
      return;
    }

    setLoading(true);
    try {
      const res = await context.updateSubscriptionFeatureFlag({
        subscriptionId: rowData.id,
        featureFlagId: featureFlag.product_entitlement.id,
        featureFlag: checked
      });
      if (res?.data?.update_feature_flag?.message) {
        message.success(res.data.update_feature_flag.message);
        node?.setDataValue(colDef.field, checked);
      }
    } catch (error) {
      message.error("Failed to update feature flag");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Switch
      defaultChecked={value}
      disabled={loading}
      onChange={handleChange}
      loading={loading}
      size="small"
      unCheckedChildren="OFF"
      checkedChildren="ON"
    />
  );
}

// Cell renderer for project-level switches
export function ProjectSwitchCellRenderer({
  value,
  data: rowData,
  context,
  colDef,
  node,
  readonly
}: any) {
  const [loading, setLoading] = useState(false);

  const handleChange = async (checked: boolean) => {
    if (readonly) return;

    const feature = colDef?.field?.split(".")[0];
    if (!feature || !rowData.id) return;

    const featureFlag = rowData.project_product_entitlements?.find(
      (e: any) => e.product_entitlement?.feature === feature
    );

    if (!featureFlag) {
      return;
    }

    setLoading(true);
    try {
      const variables: any = {
        projectId: rowData.id,
        featureFlagId: featureFlag.product_entitlement.id,
        featureFlag: checked
      };

      const res = await context.updateProjectFeatureFlag(variables);

      if (res?.data?.update_feature_flag?.message) {
        message.success(res.data.update_feature_flag.message);
        node?.setDataValue(colDef.field, checked);
      }
    } catch (error) {
      message.error("Failed to update project feature flag");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Switch
      defaultChecked={value}
      disabled={loading || readonly}
      onChange={handleChange}
      loading={loading}
      size="small"
      unCheckedChildren="OFF"
      checkedChildren="ON"
    />
  );
}
